import { CoreImpl8in9la2y2fyb as CoreImpl } from '../core-core-kernel.mjs';
//region block: imports
export * from '../core-core-api.mjs'
export * from '../core-core-experimental.mjs'
export * from '../core-core-kernel.mjs'
export * from '../core-core-range-dynamic-range.mjs'
export * from '../core-core-stl.mjs'
export * from '../core-test-helpers.mjs'
export * from '../ipex-range-format.mjs'
export * from '../ipex-room-definitions.mjs'
//endregion
//region block: pre-declaration
//endregion
function createCore() {
  return new CoreImpl();
}
//region block: exports
export {
  createCore as createCore,
};
//endregion

//# sourceMappingURL=core.mjs.map
